var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-code"},[_c('div',{staticClass:"code"},[_c('VueQrcode',{staticClass:"qr-code",attrs:{"text":_vm.qrUrl,"size":_vm.size,"margin":10}})],1),_c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('FoodC_20240607_eLRx_hJRj')))]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.$t('FoodC_20240607_RSyh_XJnN')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }